export default __webpack_public_path__ + "static/media/27-3197768.2db4989b.png";